import React, { useEffect, useState, forwardRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {useSelector} from 'react-redux';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import dashboardService from '../services/dashboard';
import { DialogDetail } from './DialogDetail';
import moment from 'moment';


import MaterialTable, { MTableHeader } from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { parseJwt } from '../utils/helper';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const useStyles = makeStyles((theme) => ({
    dashboardContainer: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        border: '1px solid #eee',
        borderRadius: 10,
    },
    table: {
        '& th': {
            whiteSpace: 'nowrap',
            textAlign: 'center',
            width: 200,
            color: '#fff',
            background: '#335fd4'
        },
        '& td': {
            whiteSpace: 'nowrap',
            width: 200,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        '& tr': {
            '&:nth-child(even)': {
                '& td': {
                    background: '#f5f7f8'
                }
            }
        }
    },
    dialog: {
        width: '100%',
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    dialogContent: {
        width: 600,
        padding: 20,
        boxSizing: 'border-box',
        borderTop: '1px solid #eee',
        borderBottom: '1px solid #eee',
    },
    agentList: {
        padding: 0,
        listStyle: 'none',
        margin: 0,
        '& li': {
            padding: '5px 0',
            display: 'flex',
            alignItems: "center",
            '& h6': {
                width: 200,
                fontWeight: 'bold'
            }
        }
    },
    dialogActions: {
        padding: '10px 20px',
        justifyContent: 'center',
        boxSizing: 'border-box',
    },
    proofContainer: {
        display: 'flex',
        alignItems: 'center',
        '& img': {
            margin: '0 20px 0 0',
        },
        '& a': {
            color: '#141414'
        }
    },
    formControl: {
        width: 200,
    }
}));

const Dashboard = () => {
    const classes = useStyles();
    const currentUser = useSelector(state => state.currentUser)
    const [designation, setDesignation] = useState(currentUser.designation)
    const exportColumns = {
        columns: [
            { title: 'Doctor Name', field: 'fullName', export: true }, 
            { title: 'Doctor Executive Name', field: 'seName', export: true }, 
            { title: 'Regional Sales Head Name', field: 'rshName', export: true }, 
            { title: 'Admin Name', field: 'adminName', export: true }, 
            { title: 'First Name', field: 'firstName', export: true},
            { title: 'Middle Name', field: 'middleName',export: true},
            { title: 'Last Name', field: 'lastName',export: true},
            { title: 'Gender', field: 'gender', export: true},
            { title: 'Qualification', field: 'education', export: true},
            { title: 'Yrs of Experience', field: 'experience', export: true},
            { title: 'Speciality', field: 'specialty', export: true},
            { title: 'Language', field: 'languages',export: true,},
            { title: 'Hospital / Clinic Name', field: 'HospitalName', export: true},
            { title: 'Location', field: 'locationName', export: true},
            { title: 'Address', field: 'address', export: true},
            { title: 'City Name', field: 'city', export: true},
            { title: 'State', field: 'state', export: true},
            { title: 'ZIP', field: 'pinCode', export: true},
            { title: 'Country', field: 'country', export: true},
            { title: 'Consult Mode', field: 'consultType', export: true},
            { title: 'Consultation Amount (Physical)', field: 'physicalConsultationFees', export: true},
            { title: 'Consultation Amount (Online)', field: 'onlineConsultationFees', export: true},
            { title: 'NAME AS PER BANK', field: 'bankRecordName', export: designation === 'admin' ? true : false},
            { title: 'MCI NO.', field: 'mciNumber', export: true},
            { title: 'Awards', field: 'awards', export: true},
            // { title: 'Slot timing (online consult) ; Double line is valid', field: 'slots', export: true},
            
            { title: 'Slot Timing', field: 'slots', export: true},
             
          //  { title: 'Slot timing (physical consult) ; Double line is valid', field: 'slots_phy', export: true},
          //  { title: 'Slot timing', field: 'slots', export: true},
          

            { title: 'DAYS (All Caps)', field: 'weekDays'},
            { title: 'PHONE', field: 'mobileNumber', export: true},
            { title: 'ALTERNATE PHONE', field: 'alternatePhone', export: true},
            { title: 'ALTERNATE PHONE TWO', field: 'alternatePhoneTwo', export: true},
            { title: 'PAN NUMBER', field: 'panNumber', export: designation === 'admin' ? true : false},
            { title: 'PAN CARD', field: 'panCard', render: ({panCard}) => panCard && <img style={{width: 30, height: 30}} src={`${panCard}`}/>, export: designation === 'admin' ? true : false},
            { title: 'BANK BRANCH', field: 'bankBranch', export: designation === 'admin' ? true : false},
            { title: 'REGISTRATION CERTIFICATE', render: ({registrationCertificate}) => registrationCertificate && <img style={{width: 30, height: 30}} src={`${registrationCertificate}`}/>, field: 'registrationCertificate', export: designation === 'admin' ? true : false},
        
            
            { title: 'REGISTRATION CERTIFICATE 2', render: 
            ({registrationCertificate}) => registrationCertificate && <img style={{width: 30, height: 30}} src={`${registrationCertificate}`}/>, field: 'registrationCertificate', export: designation === 'admin' ? true : false},

            { title: 'Canceled Check', render: 
            ({cancel_check}) => cancel_check && <img style={{width: 30, height: 30}} src={`${cancel_check}`}/>, field: 'cancel_check', export: designation === 'admin' ? true : false},

            // { title: 'College Name', field: 'college_name', export: true},
  
            // { title: 'Graduation Year', field: 'graduation_year', export: true},
  
            // { title: 'Education Proof', render: 
            // ({education_proof}) => education_proof && <img style={{width: 30, height: 30}} src={`${education_proof}`}/>, field: 'education_proof', export: designation === 'admin' ? true : false},

            { title: 'Btech Education Proof', render: 
            ({btech_education_proof}) => btech_education_proof && <img style={{width: 30, height: 30}} src={`${btech_education_proof}`}/>, field: 'btech_education_proof', export: designation === 'admin' ? true : false},

            { title: 'Phd Education Proof', render: 
            ({phd_education_proof}) => phd_education_proof && <img style={{width: 30, height: 30}} src={`${phd_education_proof}`}/>, field: 'phd_education_proof', export: designation === 'admin' ? true : false},

            { title: 'Diploma Education Proof', render: 
            ({diploma_education_proof}) => diploma_education_proof && <img style={{width: 30, height: 30}} src={`${diploma_education_proof}`}/>, field: 'diploma_education_proof', export: designation === 'admin' ? true : false},
            
            { title: 'Dnb Certificate', render: 
            ({dnb_certificate}) => dnb_certificate && <img style={{width: 30, height: 30}} src={`${dnb_certificate}`}/>, field: 'dnb_certificate', export: designation === 'admin' ? true : false},

            { title: 'Speciality Certificate', render: 
            ({speciality_certificate}) => speciality_certificate && <img style={{width: 30, height: 30}} src={`${speciality_certificate}`}/>, field: 'speciality_certificate', export: designation === 'admin' ? true : false},

           { title: 'Fellowship Certificate', render: 
           ({fellowship_certificate}) => fellowship_certificate && <img style={{width: 30, height: 30}} src={`${fellowship_certificate}`}/>, field: 'fellowship_certificate', export: designation === 'admin' ? true : false},
           
           { title: 'Membership', field: 'membership', export: true},

           { title: 'Conditions & Procedure', field: 'conditions_procedure', export: true},
  
           { title: 'Services Offered', field: 'services_offered', export: true},

           { title: 'Publication Link', field: 'publication_link', export: true},

           { title: 'Adhar Backside', render: 
           ({adhar_backside}) => adhar_backside && <img style={{width: 30, height: 30}} src={`${adhar_backside}`}/>, field: 'adhar_backside', export: designation === 'admin' ? true : false},
           
           { title: 'Canceled Check', render: 
           ({cancel_check}) => cancel_check && <img style={{width: 30, height: 30}} src={`${cancel_check}`}/>, field: 'cancel_check', export: designation === 'admin' ? true : false},
           
            { title: 'ACCOUNT NUMBER', field: 'accountNumber', export: designation === 'admin' ? true : false},
            { title: 'ADDRESS PROOF', render: ({uploadAddressProof}) => uploadAddressProof && <img style={{width: 30, height: 30}} src={`${uploadAddressProof}`}/>, field: 'uploadAddressProof', export: designation === 'admin' ? true : false},
            { title: 'ADDRESS PROOF TYPE', field: 'addressProof', export: designation === 'admin' ? true : false},
            { title: 'IFSC CODE', field: 'ifscCode', export: designation === 'admin' ? true : false},
            { title: 'EMAIL ID', field: 'emailAddress', export: true},
            { title: `SECRETARY'S NAME (IF AVAILABLE)`, field: 'secretaryName', export: true},
            { title: `SECRETARY'S NUMBER (IF AVAILABLE)`, field: 'secretaryNo', export: true},
            { title: 'IMAGEURL', field: 'profilePicture',
            render: ({profilePicture}) => profilePicture && <img style={{width: 30, height: 30}} src={`${profilePicture}`}/>, export: true},
            { title: 'THUMBNAILURL', field: 'profilePicture', 
            render: ({profilePicture}) => profilePicture && <img style={{width: 30, height: 30}} src={`${profilePicture}`}/>, export: true},
            { title: 'Display name', field: 'displayName', export: true},
            { title: 'Registration Date', field: 'createdDate', export: true,
            render: ({createdDate}) => <div>{createdDate}</div>},
            { title: 'Status', field: 'status', export: true},
        ]
    }
    const [open, setOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [applications, setApplications] = useState([])
    const [data, setData] = React.useState(exportColumns);

    function fetchApplications() {
        setIsLoading(true)
        dashboardService.getApplications().then(({ data }) => {
            setApplications(data.doctorsData.map(({degreeCertificate, panCard, profilePicture, registrationCertificate, uploadAddressProof, ...rest})=> {
                return ({...rest, degreeCertificate: `${degreeCertificate}`, panCard: `${panCard}`, profilePicture: `${profilePicture}`, registrationCertificate: `${registrationCertificate}`, uploadAddressProof: `${uploadAddressProof}`})
            }))
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        fetchApplications()
    }, [])

    useEffect(()=> {
        setData({columns: exportColumns.columns})
    },[designation])
    useEffect(()=> {
        if (currentUser.user.token && currentUser.user.token.length) {
            const token = parseJwt(currentUser.user.token)
            setDesignation(token.designation)
        }
    },[currentUser.user.token])
    const handleClose = (value) => {
        if (value) {
            const payload = {...value, phone: selectedRow.mobileNumber, description: "test"}
            dashboardService.updateStatus(payload).then((data)=> {
                alert('Status Changed and Mail Sent Successfully')
            }).catch((e)=> {
                console.error(e)
                throw e
            })
            .finally(()=> {
                setOpen(false);
                fetchApplications()
            })
        } else {
            setOpen(false);
        }

    };

    return (
        <div className={classes.dashboardContainer}>
            <MaterialTable
                components={{
                    Header: props => {
                      return (
                        <MTableHeader {...props} >
                        </MTableHeader>
                    )
                    }
                }}
                icons={tableIcons}
                title="Report"
                columns={data.columns}
                options={{
                    exportButton: true,
                    actionsColumnIndex: 0,
                    exportAllData: true,
                    headerStyle: {
                    }
                }}
                style={{
                }}
                actions={[
                    {
                        icon: () => <Button>View</Button>,
                        tooltip: 'View User',
                        onClick: (event, rowData) => {
                            console.log(event, rowData)
                            setOpen(true)
                            setSelectedRow(rowData)
                        }
                    },
                    {
                        icon: () => <Button>Edit</Button>,
                        tooltip: 'View User',
                        onClick: (event, rowData) => {
                            console.log('rowdata',rowData)
                        window.open(`${window.location.origin}/register/${rowData.semobileNumber}/edit/${rowData.mobileNumber}`)
                        }
                    }
                ]}
                data={applications} />
                <DialogDetail selectedRow={selectedRow} handleClose={handleClose} open={open}/>
           
        </div>
    )
}

export default Dashboard;